<svelte:head>
	<!-- Primary Meta Tags -->
  <title>D-NS Studio | {pageTitle}</title>
  <meta name="title" content="D-NS Studio | {pageTitle}">
  <meta name="description" content={pageDesc}>
	<!-- FB Tags -->
	<meta property="og:url" content="https://d-ns-studio{urlPath}">
  <meta property="og:title" content="D-NS Studio | {pageTitle}">
  <meta property="og:description" content={pageDesc}>
  <meta property="og:image" content={pageImage}>

	<!-- Twitter Tags -->
	<meta property="twitter:url" content="https://d-ns-studio{urlPath}">
  <meta property="twitter:title" content="D-NS Studio | {pageTitle}">
  <meta property="twitter:description" content={pageDesc}>
  <meta property="twitter:image" content={pageImage}>

</svelte:head>

<script>
export let pageTitle = 'Todas tus clases, sin salir de casa';
export let pageDesc = 'Mientras trabajas, estudias o haces ejercicio desde casa, permítenos acompañarte con estas sesiones que nuestros instructores ofrecen para tí.';
export let pageImage = 'https://d-ns.studio/images/background-02.jpg';
export let urlPath = '/';
</script>